import "./Tabs.scss";

export default function Tabs({ tabs, active, onChange }) {
    return (
        <div className="tabs">
            {tabs.map(({ label, value }) => (
                <button
                    key={value}
                    className={active === value ? "active" : ""}
                    onClick={() => onChange(value)}
                >
                    {label}
                </button>
            ))}
        </div>
    );
}
